import { render } from "./HomeIndex.vue?vue&type=template&id=3ba67e3c&scoped=true"
import script from "./HomeIndex.vue?vue&type=script&lang=js"
export * from "./HomeIndex.vue?vue&type=script&lang=js"

import "./HomeIndex.vue?vue&type=style&index=0&id=3ba67e3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba67e3c"]])

export default __exports__